import React from 'react';
import AuthPageContainer from './container';
import ForgotPasswordForm from 'components/login/forgot';
import ForgotHeader from '../login/forgotHeader';
import SignupButton from './SignupButton';
import SignupFooter from './SignupFooter';

export default function ForgotPasswordPage() {
  return (
    <AuthPageContainer renderNav={SignupButton} renderFooter={SignupFooter}>
      <ForgotHeader />
      <ForgotPasswordForm />
    </AuthPageContainer>
  );
}
